import Vue from 'vue';
import NumAbbr from 'number-abbreviate';

const numAbbr = new NumAbbr();

Vue.filter('abbreviateNumber', function (value: any) {
  return numAbbr.abbreviate(value, 1);
});
